import { useState } from 'react';
import { StatusFeedback, Text } from '../../../components/core';
import { IconAlertTriangle } from '../../../components/icons/IconAlertTriangle';
import { ConfirmLeaveModal } from '../../../components/modals/ConfirmLeaveModal';
import { useBreakpointSwitch } from '../../../contexts/breakpointContext';
import { usePortalContext } from '../../../contexts/portalContext';
import { getRoute } from '../../../routes';
import { Portals } from '../../portal/portals';
import { usePortalNavigate } from '../../portal/usePortalNavigate';

export const InputMonitorWarning = ({ isVisible }: { isVisible: boolean }): JSX.Element => {
  const [showModal, setShowModal] = useState(false);
  const portalNavigate = usePortalNavigate();
  const { onlyIfPortalIsActive } = usePortalContext();

  const connectNowEnabled = onlyIfPortalIsActive(Portals.ConnectNow, true, false);

  const [verticalFeedback] = useBreakpointSwitch({
    mobile: [true],
    desktop: [false],
  });

  const onConfirm = (): void => {
    portalNavigate(
      Portals.ConnectNow,
      getRoute('connectNowHome', {}),
      getRoute('crisisResources', {}),
    );
  };

  const warningText = connectNowEnabled
    ? 'Answers to this form are not monitored in real time. If you need immediate support, use ConnectNow or a provided crisis resource.'
    : 'Answers to this form are not monitored in real time. If you need immediate support, please see available crisis resources.';

  const buttonText = connectNowEnabled ? 'Visit ConnectNow' : 'Visit Crisis Resources';

  return (
    <>
      <StatusFeedback.warning
        isDisabled={!isVisible}
        testID="input-monitor-warning"
        Icon={IconAlertTriangle}
        buttonText={buttonText}
        onPress={() => setShowModal(true)}
        vertical={verticalFeedback}
      >
        <Text.paraSmall bold>Reminder:</Text.paraSmall> {warningText}
      </StatusFeedback.warning>

      {showModal && <ConfirmLeaveModal onClose={() => setShowModal(false)} onConfirm={onConfirm} />}
    </>
  );
};
